// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchNavbarComponents-cls1_mnd","cls2":"SearchNavbarComponents-cls2_0N4 SearchNavbarComponents-cls1_mnd"};